import React from 'react';

import { Box } from '@material-ui/core';
import { Skeleton } from '@material-ui/lab';

interface Props {
  height?: number;
}

const FriendLoading: React.FC<Props> = ({ height = 40 }) => {
  return (
    <Box display="flex" justifyContent="center" alignItems="center">
      <Skeleton variant="circle" width={height} height={height} />
      <Box ml={6} flex={1}>
        <Skeleton width={200} height={16} />
      </Box>
    </Box>
  );
};

export default FriendLoading;
